export enum VisitorBanEntryType {
  Undefined = 'Undefined',
  Person = 'Person',
  Company = 'Company',
  Vehicle = 'Vehicle',
}
